import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-numberInput-control-label-view, [app-numberInput-control-label-view]',
  templateUrl: './numberInput-control-label-view.component.html',
  styleUrls: ['./numberInput-control-label-view.component.scss']
})
export class NumberInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
